module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('admin-header', {
    attrs: {
      "title": 'Tariffs',
      "uploader": true,
      "showNewButton": false,
      "disableQuickSearch": true
    },
    on: {
      "open-filter": _vm.openFilter,
      "create-entity-request": _vm.goToNewEntityScreen,
      "entity-quick-search": _vm.search,
      "csv-upload": _vm.multiSave
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "admin-header-slot"
    },
    slot: "admin-header-slot"
  }, [_c('div', {
    staticClass: "btn btn-primary sq pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Expiring Tariffs - uploaded dates MUST follow yyyy-mm-dd format!"
    },
    on: {
      "click": _vm.clickOnExpiring
    }
  }, [_vm._v("\n        Expiring Tariffs\n      ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tariffMode),
      expression: "tariffMode"
    }],
    staticClass: "sq btn btn-success",
    attrs: {
      "slot": "buttons"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tariffMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    },
    slot: "buttons"
  }, [_c('option', {
    attrs: {
      "value": "search"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "new"
    }
  }, [_vm._v("New Tariff")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "update"
    }
  }, [_vm._v("Mass Update")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "suspend"
    }
  }, [_vm._v("Mass Suspension")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unsuspend"
    }
  }, [_vm._v("Mass Unsuspension")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "admin-content"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0320c14c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/AdminTariff.vue
// module id = 2070
// module chunks = 1